import React from 'react';
import navigationConfig from './navigationConfig';
const NavigationLink = ({ label, active, icon, onClick, url, subitems, renderLink, children, className, onClickItem, forceInteractive, }) => {
    const clName = `${className || ''} ${active ? navigationConfig.ACTIVE_ITEM_CLASS_NAME : ''}`;
    if (renderLink && url) {
        return (React.createElement(React.Fragment, null, renderLink({
            item: { label, active, icon, onClick, url, subitems },
            linkProps: {
                className: clName,
                onClick: onClickItem,
                children,
            },
        })));
    }
    if (!url && onClickItem) {
        return (React.createElement("button", { className: clName, onClick: onClickItem }, children));
    }
    return (React.createElement("div", { className: clName, style: !forceInteractive ? { cursor: 'default', background: 'none' } : {} }, children));
};
export default NavigationLink;
